import { render, staticRenderFns } from "./TextRecommendationCardTitleDetailProfile.vue?vue&type=template&id=57ad0f35&scoped=true"
import script from "./TextRecommendationCardTitleDetailProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationCardTitleDetailProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationCardTitleDetailProfile.vue?vue&type=style&index=0&id=57ad0f35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad0f35",
  null
  
)

export default component.exports